import { optionField, booleanField } from '@/common/utils/form/fieldTypes';

export const external_email_type = 'external_email_type';
export const external_email_status = 'external_email_status';
export const purchasing_email_status = 'purchasing_email_status';

export type ExternalEmailType =
  | {
      label: string;
      value: string;
    }
  | string
  | null;

export type ExternalEmailStatus =
  | {
      label: string;
      value: string;
    }
  | string
  | null;

export type ExternalEmailIntegrationType = {
  [external_email_type]: ExternalEmailType;
  [external_email_status]: ExternalEmailStatus;
  [purchasing_email_status]: boolean;
};

const config = {
  [external_email_type]: optionField(),
  [external_email_status]: optionField(),
  [purchasing_email_status]: booleanField()
};

export default config;
